/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputChatChannelReadStatus
 */
export interface OutputChatChannelReadStatus {
    /**
     * 
     * @type {number}
     * @memberof OutputChatChannelReadStatus
     */
    channelId: number;
    /**
     * 
     * @type {number}
     * @memberof OutputChatChannelReadStatus
     */
    unreadCount: number;
}

/**
 * Check if a given object implements the OutputChatChannelReadStatus interface.
 */
export function instanceOfOutputChatChannelReadStatus(value: object): boolean {
    if (!('channelId' in value)) return false;
    if (!('unreadCount' in value)) return false;
    return true;
}

export function OutputChatChannelReadStatusFromJSON(json: any): OutputChatChannelReadStatus {
    return OutputChatChannelReadStatusFromJSONTyped(json, false);
}

export function OutputChatChannelReadStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputChatChannelReadStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'channelId': json['channelId'],
        'unreadCount': json['unreadCount'],
    };
}

export function OutputChatChannelReadStatusToJSON(value?: OutputChatChannelReadStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'channelId': value['channelId'],
        'unreadCount': value['unreadCount'],
    };
}

